import { useEffect, useState } from "react";

import { PiggyBank, User, Wallet } from "lucide-react";
import CustomLoader from "./CustomLoader";
import api from "../utils/axios";

import { formatCurrency, formatNumber, formatAmount } from "../helpers";
const GiftUsedUser = () => {
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [betHistory, setBetHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState(null);
  const [searchRef, setSearchRef] = useState("");

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      setError("No token found. Please log in.");
      setLoading(false);
      return;
    }
    fetchUserApiBetHistory(page, limit);
  }, [page]);

const fetchUserApiBetHistory = async (page, limit, searchRef) => {
  setLoading(true);
  try {
    const response = await api.get(
      `/getAllUserBonusHistory?page=${page}&pageSize=${limit}&bonus_type=redenvelope${
        searchRef ? `&reference_id=${searchRef}` : ""
      }`
    );

    const { data, pagination } = response.data;

    setBetHistory(data);
    setTotalPages(pagination.totalPages || 1);
    setPage(pagination.currentPage || 1);
  } catch (err) {
    console.error("Failed to fetch bonus history:", err);
    setError("Failed to fetch bonus history");
  } finally {
    setLoading(false);
  }
};

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  useEffect(() => {
  if (!token) {
    setError("No token found. Please log in.");
    setLoading(false);
    return;
  }

  fetchUserApiBetHistory(page, limit, searchRef);
}, [page, searchRef]);

  return (
     <div className="space-y-8">
        <div>
        <h1 className="text-2xl font-bold text-gray-800">
            Gift Used User
        </h1>
        <p className="text-sm text-gray-500">
          Manage your gift usage history here
        </p>
       </div>

        {loading ? (
            <CustomLoader/>
        ) : error ? (
            <p className="text-red-600">{error}</p>
        ) : (
            <>
           

           <div className="flex justify-between items-center mb-4">
  <input
    type="text"
    placeholder="Search by Reference ID..."
    value={searchRef}
    onChange={(e) => {
      setPage(1); // reset page on search
      setSearchRef(e.target.value);
    }}
    className="border px-4 py-2 rounded w-64 focus:outline-none focus:ring-2 focus:ring-blue-400"
  />
</div>

            <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-200 divide-y divide-gray-200">
               <thead className="bg-gray-100 text-gray-700">
  <tr>
    <th className="px-4 py-3 text-left text-sm font-bold">#</th>
    <th className="px-4 py-3 text-left text-sm font-bold">User ID</th>
    <th className="px-4 py-3 text-left text-sm font-bold">Bonus Type</th>
    <th className="px-4 py-3 text-left text-sm font-bold">Source</th>
    <th className="px-4 py-3 text-left text-sm font-bold">Reference ID</th>
    <th className="px-4 py-3 text-left text-sm font-bold">Bonus %</th>
    <th className="px-4 py-3 text-left text-sm font-bold">Bonus Amount</th>
    <th className="px-4 py-3 text-left text-sm font-bold">Status</th>
    <th className="px-4 py-3 text-left text-sm font-bold">Created At</th>
  </tr>
</thead>
               <tbody className="text-sm text-gray-800 divide-y divide-gray-200">
  {betHistory.map((item, index) => (
    <tr key={item.id} className="hover:bg-gray-50">
      <td className="px-4 py-3">
        {(page - 1) * limit + index + 1}
      </td>
      <td className="px-4 py-3">{item.uid}</td>
      <td className="px-4 py-3">{item.bonus_type}</td>
      <td className="px-4 py-3">{item.source}</td>
      <td className="px-4 py-3">{item.reference_id}</td>
      <td className="px-4 py-3">{item.bonus_percent}%</td>
      <td className="px-4 py-3">
        {formatCurrency(item.bonus_amount)}
      </td>
      <td className="px-4 py-3 capitalize">{item.status}</td>
      <td className="px-4 py-3">
        {new Date(item.created_at).toLocaleString()}
      </td>
    </tr>
  ))}
</tbody>
                </table>
            </div>

            <div className="mt-6 flex justify-center items-center space-x-4">
                <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 1}
                className={`px-4 py-2 rounded ${
                    page === 1
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                }`}
                >
                Prev
                </button>
                <span className="text-gray-700">
                Page <strong>{page}</strong> of <strong>{totalPages}</strong>
                </span>
                <button
                onClick={() => handlePageChange(page + 1)}
                disabled={page === totalPages}
                className={`px-4 py-2 rounded ${
                    page === totalPages
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                }`}
                >
                Next
                </button>
            </div>
            </>
        )}
        </div>

  );
};

export default GiftUsedUser;
